"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var _ = tslib_1.__importStar(require("@antv/util"));
var plot_1 = tslib_1.__importDefault(require("../../base/plot"));
var layer_1 = tslib_1.__importDefault(require("./layer"));
var Radar = /** @class */ (function (_super) {
    tslib_1.__extends(Radar, _super);
    function Radar() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Radar.prototype.createLayers = function (props) {
        var layerProps = _.deepMix({}, props);
        layerProps.type = 'radar';
        _super.prototype.createLayers.call(this, layerProps);
    };
    Radar.getDefaultOptions = layer_1.default.getDefaultOptions;
    return Radar;
}(plot_1.default));
exports.default = Radar;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@antv/g2plot/lib/plots/radar/index.js
// module id = 952
// module chunks = 37